module.exports = __webpack_public_path__ + "img/circle.be9c18a6.svg";